import 'angular';
import './approver_entry.html';
import {RootScope} from "../../../types/angular-types";
import {IApprovalUtils} from '../../ApprovalUtils';



angular.module('GorillaBoy.Approvals')
    .directive('approverEntry', ['$rootScope', 'ApprovalUtils', ($rootScope: RootScope, ApprovalUtils: IApprovalUtils) => {
        return {
            restrict: 'E',
            scope: {
                approver: '='
            },
            templateUrl: './approvals/approvalView/approverEntry/approver_entry.html',
            link: function($scope, $element, attrs) {
                $scope.getFullName = $rootScope.getFullName;

                $scope.getApprovalStatusText = ApprovalUtils.getApprovalStatusText;

                $scope.getApprovalStatusIndicator = ApprovalUtils.getApprovalStatusIndicator;
            }
        };
    }]);